import { Payload } from '@smile-next/uikit';

export class AuthenticatedSuccessPayload extends Payload {
    type = 'AuthenticatedSuccessPayload';
}
